(ns frontend.view.components.form.components.form-cancel-button)

(defn view [on-cancel!]
  [:a
   {:href          "#"
    :class-name    "cancel-btn"
    :tab-index     "-1"
    :on-mouse-down (fn [e]
                     (on-cancel! e)
                     (-> e .-target .-parentElement .focus))} ;; cause input to blur -> hide cancel button
   [:i.fal.fa-undo
    {:aria-hidden true}]])
